import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cred-in.com/company/",
    target: "_blank"
  }, "運営会社")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "copyright" }, "© YUMEKANAERUPROJECT CO.,LTD", -1)

import { RouterLink } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), { to: { name: 'termOfService' } }, {
                default: _withCtx(() => [
                  _createTextVNode("利用規約")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), { to: { name: 'specifiedCommercialTransactionAct' } }, {
                default: _withCtx(() => [
                  _createTextVNode("特定商取引法")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), { to: { name: 'privacyPolicy' } }, {
                default: _withCtx(() => [
                  _createTextVNode("プライバシーポリシー")
                ]),
                _: 1
              })
            ]),
            _hoisted_5
          ])
        ]),
        _hoisted_6
      ])
    ])
  ]))
}
}

})